import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { createPortal } from 'react-dom';
import type { Position } from '../../../../types';
import { positionAdjust, positionCheck } from '../../../helpers';
import { Deactivation, useTheme } from '../../common';
import { Duration } from '../playlist';
import { Background } from './widget-types';

export function FloatingBackground() {
  const { textColor } = useTheme();

  const { position, playerControls = [], font, closeButton } = useSettings();

  const controlsLength = playerControls.length + Number(closeButton);

  return createPortal(
    <Deactivation>
      <Container
        _position={position}
        _inline={controlsLength <= 4}
        _color={textColor}
        _font={font?.value || 'inherit'}
      >
        <Inner
          _circle={controlsLength === 1 && !playerControls.includes('prevNext')}
        >
          <Background />
        </Inner>
      </Container>
    </Deactivation>,
    document.body
  );
}

const Container = styled.div<{
  _position: Position;
  _inline: boolean;
  _color: string;
  _font: string;
}>`
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 999999999;

  flex-direction: ${({ _position, _inline }) => {
    if (_inline) {
      return positionCheck(_position, 'right') ? 'row-reverse' : 'row';
    }
    return positionCheck(_position, 'top') ? 'column' : 'column-reverse';
  }};
  ${({ _position }) => `
    top: ${positionAdjust(_position, 'top')};
    bottom: ${positionAdjust(_position, 'bottom')};
    left: ${positionAdjust(_position, 'left')};
    right: ${positionAdjust(_position, 'right')};
  `}
  color: ${({ _color }) => _color};
  font-family: ${({ _font }) => _font};

  & ${Duration} {
    margin-left: auto;
  }
`;

const Inner = styled.div<{ _circle: boolean }>`
  box-shadow: 0 0 10px 0 rgba(17, 17, 17, 0.2);
  border-radius: ${({ _circle }) => (_circle ? '50%' : '8px')};
`;
